<template>
    <div class="pop_overay">
        <div class="pop_cont">
            <img class="icon_img" src="@/assets/images/popup_icon.png" alt="icon">
            <div class="text_2 noviewpop">
                <div class="stamp_success wonju">
                  <b class="wonju3tit">{{korea_east ? '해파랑길' : '남파랑길'}} 완보를 축하드립니다.</b><br>
                  {{korea_east ? '해파랑길' : '남파랑길'}}을 완보하신 분께는 한국관광공사에서 완보증과 기념품을 드립니다.<br/><br/>
                  - {{korea_east ? '해파랑길' : '남파랑길'}} 완보증 발급 문의 -<br/>
                  한국의길과문화 02-6013-6610~3
                </div>
            </div>
            <button @click="closeBtn">확인</button>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'KoreaPopup',
  data () {
    return {}
  },
  computed: {
    ...mapState(['korea_east', 'korea_south'])
  },
  methods: {
    closeBtn () {
      this.$store.state.koreaPopup = false
    }
  },
  mounted () {
  },
  destroyed () {
  }
}
</script>
<style>
  .wonju3tit {
    display: inline-block;
    margin-bottom:5px;
    font-size: 1.1em;
  }
  .arrows {
    width:10px;
    position: relative;
    top: 2px;
    margin:0 5px;
  }
  .wonju {
    color:#000;
    font-size: 17px;
    font-family:inaviL;
    line-height:1.5;
    padding:0 5px;
    word-break: keep-all;
  }
</style>
